var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchSpeed"},_vm._l((_vm.washServiceSpeedList),function(item,index){return _c('div',{key:index,staticClass:"speed-item",on:{"click":function($event){return _vm.onSpeed(item)}}},[_vm._v("\n        "+_vm._s(item.speedName)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }